/********************************************
 * Values Slider
 *
 * Flickity carousel
 * https://flickity.metafizzy.co/
 ********************************************/
function fnLogosSlider(i, oSection) {

    /*****************
     * Objects
     *****************/
    var oSection = $(oSection),
        oCarousel = $('.carousel', oSection),
        oArrows	= $( '.controls', oSection ),
        oSlides = $('.slide', oSection);


    /*****************
     * Carousel configuration
     *****************/

    /**
     * Initialise Flickity
     */

    if (oSlides.length > 1) {
        var $oFlickity = oCarousel.flickity({
            isDraggable: false,
            wrapAround: true,
            cellAlign: 'center',
            accessibility: false,
            prevNextButtons: false,
            pageDots: false,
            fade: false,
        });

        /**
         * Arrow buttons (prev/next)
         */
        oArrows.find( '.next' ).on( 'click', function() {
            $oFlickity.flickity( 'next' );
        });
        oArrows.find( '.previous' ).on( 'click', function() {
            $oFlickity.flickity( 'previous' );
        });
    }

}


// END OF DOCUMENT
